import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectDetail from '@app/views/Project/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
